import React from 'react';
import { Loading } from './Loading';

// 이미 그려진 화면(달력·지도 등) 위를 덮는 로딩 표시 (U-45).
// 부모에 position: relative 가 있어야 한다. show 가 false 면 아무것도 그리지 않는다.
export const LoadingOverlay = ({ show }) => {
	if (!show) return null;
	return (
		<div
			style={{
				position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 5,
				display: 'flex', alignItems: 'center', justifyContent: 'center',
				background: 'rgba(255, 255, 255, 0.7)',
			}}>
			<Loading />
		</div>
	);
};
